import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import {
  InstructionPartsTitle,
  InstructionGridContainer,
  InstructionGridItem,
} from '~/src/components/molecules'

import { TPartsItem } from '~/src/types/instruction'

interface IPlanIncludedPartsProps {
  planParts: TPartsItem[]
}

/**
 * PlanIncludedParts
 *
 * @param __namedParameters IPlanIncludedPartsProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const PlanIncludedParts: React.FC<IPlanIncludedPartsProps> = ({ planParts }) => {
  const { t } = useTranslation()

  return (
    <>
      <InstructionPartsTitle title={'Plan Included Parts'} />

      <Box component="div" sx={{ flexGrow: 1 }}>
        <InstructionGridContainer>
          <InstructionGridItem text={'Front seats'} />
          <InstructionGridItem text={'Front seats'} />
          <InstructionGridItem text={'Front seats'} />
          <InstructionGridItem text={'Front seats'} />
        </InstructionGridContainer>
        <InstructionGridContainer>
          <InstructionGridItem text={'Front seats'} />
          <InstructionGridItem text={'Front seats'} />
          <InstructionGridItem text={'Front seats'} />
          <InstructionGridItem text={'Front seats'} />
        </InstructionGridContainer>
        {planParts.length > 0 &&
          planParts.map((item: TPartsItem, index: number) => {
            console.log(index)
            if (index === 0 || index === index * 4) {
              return (
                <InstructionGridContainer key={item.itemName}>
                  <InstructionGridItem text={item.itemName} />
                </InstructionGridContainer>
              )
            }
          })}
      </Box>
    </>
  )
}
